"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callJSBridgeHandler = callJSBridgeHandler;
const tslib_1 = require("tslib");
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
function callJSBridgeHandler(protocolName, options = {}, callback) {
    nnq_1.default.initBridge({}, (res) => {
        if (res?.bridge) {
            res.bridge.callHandler(protocolName, { ...options }, callback);
        }
        else {
            console.error('NNQ bridge not initialized');
        }
    });
}
